// extracted by mini-css-extract-plugin
module.exports = {"container":"RequisitionResultsPDFStyles_container__10xKv","text":"RequisitionResultsPDFStyles_text__3Bq9v","buttons":"RequisitionResultsPDFStyles_buttons__ujZPe"};